// Sidebar.js
import React from "react";
import { Layout, Row, Divider } from "antd";
import "./root.less";
import Spinner from "../Spinner";
import useSidebar from "../../custom-hooks/useSidebar";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const { Sider } = Layout;
const Sidebar = () => {
  const [content, isLoading] = useSidebar();

  if (isLoading) {
    return <Spinner />;
  }
  if (!content) return <></>; // Handle missing sidebar content
  const renderOptions = {
    renderNode: {
      hr: (node) => (
        <Divider variant="dashed" style={{ margin: 0, borderColor: "grey" }} />
      ),
    },
  };
  return (
    <Row
      style={{
        display: "flex",
        alignItems: "flex-start",
      }}
    >
      <Sider
        width={400}
        className="sidebar"
        breakpoint="lg"
        collapsedWidth={0}
        trigger={null}
      >
        <Row style={{ padding: "24px", marginBottom: "50px" }}>
          {documentToReactComponents(content, renderOptions)}
        </Row>
      </Sider>
    </Row>
  );
};

export default Sidebar;
